import Vue from 'vue'
import Buefy from 'buefy'
import VueRouter from 'vue-router'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(Buefy)
Vue.use(VueRouter)

const routes = [
  {
     path: "/",
     component: () => import("@/views/Home")
   },
  {path: '/paintings', component: () => import("@/views/Paintings") },
  {path: '/archive/:page', component: () => import("@/views/Archive")},
  {path: '/dump/:page', component: () => import("@/views/Dump") },
  {path: '/d/:page', component: () => import("@/views/Editor") },
  {path: '/demos/:demo', component: () => import("@/views/Demos") },
  {path: '/pf', component: () => import("@/views/PIXIFilters") },
]

const router = new VueRouter({routes})


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
